import styled from "styled-components";

export const StyledPageTitleSubtitle = styled.div`
  .title {
    font-family: "Noto Sans Hebrew", sans-serif;
    font-weight: 900;
    font-size: 24.18px;
    line-height: 24.18px;
    letter-spacing: -0.33px;
    text-align: center;
    margin: 0;
    margin-bottom: 12px;
  }

  .subtitle {
    font-family: "Noto Sans Hebrew", sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    letter-spacing: -0.22px;
    text-align: center;
    margin: 0;
    margin-bottom: 24px;
  }
`;
